/**
 * Only what the screens a Brazilian business reaches in the legacy app render
 * (Business Info, Manage Team, Branded Coin, Offer details). Anything missing
 * falls back to en-US through `fallbackLocale`.
 */
export default {
  buttons: {
    save: 'Salvar',
    back: 'Voltar',
    next: 'Próximo',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    continue: 'Continuar',
    submitting: 'Enviando...',
    loading: 'Carregando...',
    retry: 'Tentar novamente',
    saveChanges: 'Salvar alterações'
  },
  alerts: {
    fieldsError: 'Confira os campos destacados abaixo',
    highlightedItemsError: 'Confira os campos destacados abaixo',
    businessLoadError:
      'Não foi possível carregar as informações do seu negócio. Atualize a página e tente novamente.'
  },
  pluralize: {
    coin: 'Coin | Coins',
    member: 'membro | membros',
    day: 'dia | dias',
    offer: 'Mimo | Mimos',
    week: 'semana | semanas',
    month: 'mês | meses',
    year: 'ano | anos'
  },
  components: {
    inputWrapper: {
      optional: 'Opcional'
    },
    table: {
      empty: 'Não há resultados para mostrar.'
    },
    groupedLocationsByCity: {
      redemptions: 'Resgates: {count}'
    },
    socialMediaButton: {
      copyLink: 'Copiar link',
      more: 'Mais'
    },
    socialShareButton: {
      linkCopied: 'Link copiado.'
    },
    colorPicker: {
      label: 'Escolha uma cor'
    },
    coinCustomizationForm: {
      title: 'Personalize sua Coin',
      borderColorLabel: 'Escolha a cor da borda'
    },
    customSelect: {
      loading: 'Carregando...',
      empty: 'Nenhum resultado para mostrar.',
      apply: 'Aplicar',
      clearFilters: 'Limpar filtros',
      search: 'Buscar'
    },
    dropDownLocations: {
      all: 'Todas',
      allLocations: 'Todas as unidades',
      locations: 'Unidades',
      addMoreLater: 'Você pode adicionar mais unidades depois.'
    },
    cropModal: {
      backgroundColor: 'Cor de fundo',
      white: 'Branco',
      black: 'Preto'
    },
    selectDropdownField: {
      optional: 'Opcional',
      multiselect: {
        placeholder: 'Selecione uma opção',
        tagPlaceholder: 'Pressione Enter para criar uma tag',
        selectLabel: 'Pressione Enter para selecionar',
        selectGroupLabel: 'Pressione Enter para selecionar o grupo',
        selectedLabel: 'Selecionado',
        deselectLabel: 'Pressione Enter para remover',
        deselectGroupLabel: 'Pressione Enter para desmarcar o grupo',
        noOptions: 'A lista está vazia.',
        noResult: 'Nenhum item encontrado. Tente buscar de outro jeito.'
      }
    },
    interactiveCoin: {
      btnNextLabel: 'Próximo',
      btnSaveLabel: 'Salvar',
      errorImgUpload: 'Não foi possível enviar as imagens. Tente novamente.',
      errorReserveInfos:
        'Não foi possível salvar as informações da Coin. Tente novamente.',
      errorNameUnavailable:
        'Esse nome de Coin não está disponível. Escolha outro nome e tente novamente.',
      errorGeneral: 'Ops, algo deu errado. Tente novamente.'
    },
    imageUploadBlock: {
      uploadFailed: 'Falha no envio',
      retryUpload: 'Tentar novamente',
      label: 'Envie seu logo ou uma imagem',
      edit: 'Editar',
      click:
        '<span class="btn">Clique para enviar</span> ou<br/>arraste e solte a imagem aqui',
      formatAcceptable: 'São aceitos arquivos JPEG ou PNG.',
      helpText:
        'Use um arquivo JPEG, PNG ou SVG. Recomendamos no mínimo 420 x 420 px e até 5 MB.',
      warnFormatFile: 'Selecione uma imagem no formato correto: JPEG ou PNG.',
      warnMaximumFileSize: 'O tamanho máximo do arquivo é 10 MB.',
      warnMaximumFileSize5: 'O tamanho máximo do arquivo é 5 MB.',
      maximumFileSizeLabel: 'Até 10 MB.',
      cropTitleDefault: 'Ajuste sua imagem'
    },
    phoneInput: {
      placeholderSearch: 'Busque seu país',
      optional: 'Opcional',
      title: 'Selecione o país'
    }
  },
  validations: {
    fields: {
      businessName: {
        required: 'Informe o nome do negócio'
      },
      phone: {
        required: 'Informe um telefone'
      },
      phone_input: {
        required: 'Informe um telefone'
      },
      category: {
        required: 'Selecione uma categoria'
      },
      website: {
        required: 'Informe um endereço',
        url: 'Informe um endereço válido'
      },
      instagram: {
        url: 'Informe um endereço válido do Instagram'
      },
      facebook: {
        url: 'Informe um endereço válido do Facebook'
      },
      name: {
        required: 'Informe um nome'
      },
      email: {
        required: 'Informe um e-mail',
        email: 'Informe um e-mail válido'
      },
      password: {
        required: 'Informe uma senha',
        min: 'Use {length} ou mais caracteres',
        hasLetter: 'A senha precisa ter pelo menos uma letra',
        hasNumber: 'A senha precisa ter pelo menos um número'
      },
      axxess: {
        password: 'Pelo menos 8 caracteres, uma letra e um número.'
      },
      'manager-name': {
        required: 'Informe seu nome'
      },
      'manager-lastname': {
        required: 'Informe seu sobrenome'
      },
      image: {
        required_image: 'Escolha uma imagem'
      },
      color: {
        required: 'Escolha uma cor'
      }
    }
  },
  signIn: {
    genericErrorMessage:
      'Algo deu errado. Tente novamente ou entre com Google/Apple.',
    errorCredentials:
      'A combinação de e-mail e senha está incorreta. Tente novamente!',
    accountAlreadyActive:
      'Sua conta já está ativa. Entre com seu e-mail e senha.',
    title: {
      default: 'Olá, que bom ver você de novo!',
      invite: 'Boas-vindas!',
      axxess: 'Boas-vindas à Twism!'
    },
    description: {
      inviteDashboard:
        'Você já tem uma conta na Twism. Use as mesmas credenciais abaixo para entrar e acessar o Portal do Lojista',
      inviteApp:
        'Você já tem uma conta no app Twism. Use as mesmas credenciais abaixo para entrar e acessar o Portal do Lojista',
      axxess: 'Entre para acessar suas ofertas'
    },
    email: 'E-mail',
    password: 'Senha',
    forgotPassword: 'Esqueceu a senha?',
    submit: 'Entrar',
    or: 'ou',
    noAccount: 'Não tem uma conta?',
    signUp: 'Cadastre-se',
    incorrectPassword: 'Senha incorreta. Tente novamente.',
    attemptLimit:
      'Você atingiu o limite de tentativas. Tente novamente em {countdown} minutos.',
    blocked:
      'Muitas tentativas sem sucesso. Sua conta foi bloqueada temporariamente.',
    contactUs: 'Fale com a gente.'
  },
  authServerMessages: {
    emailRecentlySent:
      'Já enviamos um e-mail. Tente novamente em alguns minutos.',
    userNotFound: 'Usuário não encontrado.',
    invalidEmail: 'Informe um e-mail válido',
    invalidResetToken: 'Este link de redefinição de senha é inválido.',
    expiredResetToken: 'Este link de redefinição de senha expirou.',
    weakPassword:
      'A senha precisa ter mais de {length} caracteres, com pelo menos uma letra e um número',
    generic: 'Ops, algo deu errado. Tente novamente.'
  },
  forgotPassword: {
    title: 'Esqueceu sua senha?',
    titleSent: 'Confira seu e-mail',
    description:
      'Informe seu e-mail e a Twism vai enviar as instruções para redefinir sua senha.',
    descriptionSent:
      'Enviamos um e-mail com as instruções para redefinir sua senha',
    email: 'E-mail',
    submit: 'Continuar',
    noEmailAccess: 'Não tem acesso ao seu e-mail?',
    contactUs: 'Fale com a gente',
    sentTo: 'A mensagem foi enviada para',
    openInbox: 'Abra sua caixa de entrada em uma nova aba',
    notReceived: 'Não recebeu o e-mail? Confira',
    spamFolder: 'sua caixa de spam ou',
    resend: 'clique aqui para reenviar',
    resendWait: 'aguarde {time} minutos para reenviar o e-mail;',
    loading: 'Carregando...',
    incorrectEmail: 'Este e-mail está incorreto. Tente novamente.',
    emailSent: 'Enviamos um e-mail para você.'
  },
  resetPassword: {
    title: 'Crie uma nova senha',
    description: {
      default:
        'Ao criar uma nova senha, você vai sair de todos os dispositivos associados a esta conta.',
      axxess:
        'Ao criar uma nova senha, você vai poder acessar suas ofertas da Axxess.'
    },
    firstName: 'Nome',
    lastName: 'Sobrenome',
    password: 'Senha',
    rulesLabel: 'Crie uma senha que tenha:',
    ruleLength: 'Pelo menos 8 caracteres',
    ruleNumber: 'Pelo menos um número (0-9)',
    ruleLetter: 'Pelo menos uma letra',
    helpText: {
      default: 'Pelo menos 5 caracteres.',
      axxess: 'Pelo menos 8 caracteres, uma letra e um número.'
    },
    submit: 'Criar',
    success: {
      default: {
        title: 'Sua senha foi alterada',
        description: 'Agora use sua nova senha para entrar na sua conta.',
        action: 'Voltar para o login'
      },
      axxess: {
        title: 'Sua senha foi criada',
        description: 'Agora use sua senha para entrar na sua conta.',
        action: 'Entrar'
      }
    }
  }
};
